import * as auto from './exportI18n-en'

export default {
  login: require('./login'),
  store: require('./store'),
  common: require('./common'),
  product: require('./product'),
  order: require('./order'),
  ...auto.Inject(auto)
}
